import React, { useState, useEffect } from 'react'
import { FormCorporateKatalogProgram, FormIndividuKatalogProgram } from '../..'
import useFetchUserByToken from '../../../../hooks/useFetchUserByToken'

const FormKatalogProgramFour = () => {

    const user = useFetchUserByToken()
    const categoryUser = user.user.Account !== undefined ? user.user.Account.type : undefined;
    const size = useWindowSize();

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }


    return (
        <>
            <div className='col-lg-12' style={{ marginBottom: '2%' }}>
                {
                    size.width < 500 ?
                        <h5>Metode Pembayaran & Data Peserta</h5>
                        :
                        <h3 style={{ fontSize: '20px', fontWeight: '600' }}>Metode Pembayaran & Data Peserta</h3>
                }
                <hr style={{ marginBottom: '2%', marginTop: '2%' }}></hr>
                <div className='row mb-3'>
                    <div className='col-lg-12' style={{ backgroundColor: '#FFF3CD' }}>
                        <div className='col-lg-10' style={{ color: '#856404', marginBottom: '3%' }}>
                            {
                                size.width < 500 ?
                                    <>
                                        <p style={{ fontSize: '14px', marginTop: '2%', marginBottom: '2%' }}>Perhatikan hal berikut!</p>
                                        <ul style={{ fontSize: '13px' }}>
                                            <li><b>Corporate</b> : Pembayaran dilakukan atas nama perusahaan</li>
                                            <li><b>Individu</b> : Pembayaran dilakukan secara pribadi</li>
                                            <li>Pastikan Anda telah memahami dan membaca Syarat & Ketentuan sebelum memilih metode pembayaran, Anda bisa kembali untuk melihat Syarat & Ketentuan.</li>
                                            <li>Metode pembayaran yang telah di pilih <b>tidak bisa diubah.</b></li>
                                        </ul>
                                    </>
                                    :
                                    <>
                                        <p style={{ fontSize: '20px', fontWeight: '400', marginTop: '2%', marginBottom: '2%' }}>Perhatikan hal berikut!</p>
                                        <ul style={{ fontSize: '16px' }}>
                                            <li><b>Corporate</b> : Pembayaran dilakukan atas nama perusahaan</li>
                                            <li><b>Individu</b> : Pembayaran dilakukan secara pribadi</li>
                                            <li>Pastikan Anda telah memahami dan membaca Syarat & Ketentuan sebelum memilih metode pembayaran, Anda bisa kembali untuk melihat Syarat & Ketentuan.</li>
                                            <li>Metode pembayaran yang telah di pilih <b>tidak bisa diubah.</b></li>
                                        </ul>
                                    </>
                            }

                        </div>
                    </div>
                </div>
                <div className='row mb-3'>
                    {
                        categoryUser !== undefined ?
                            categoryUser === "corporate" ?
                                <FormCorporateKatalogProgram
                                    user={user.user}
                                />
                                :
                                <FormIndividuKatalogProgram
                                    user={user.user}
                                />
                            :
                            ''


                    }
                </div>
            </div>
        </>
    )
}

export default FormKatalogProgramFour
